/** Nexus の業務日付・画面表示に使う IANA タイムゾーン。 */
export const NEXUS_TIME_ZONE = "Asia/Tokyo";

const DEFAULT_DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
};

/**
 * timezone-aware な ISO 日時または Date を JST の表示文字列へ変換する。
 *
 * @param value - API の ISO 8601 日時または Date。空値は「—」を返す。
 * @param options - 年月日時などの表示項目。タイムゾーンは常に Asia/Tokyo へ固定する。
 * @returns 日本語ロケールの JST 日時。解釈できない文字列はそのまま返す。
 */
export function formatDateTime(
  value: string | Date | null | undefined,
  options: Intl.DateTimeFormatOptions = DEFAULT_DATE_TIME_OPTIONS,
): string {
  if (value == null || value === "") return "—";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat("ja-JP", {
    ...options,
    hourCycle: "h23",
    timeZone: NEXUS_TIME_ZONE,
  }).format(date);
}

/**
 * 現在時刻をダウンロードファイル名向けの JST タイムスタンプへ変換する。
 *
 * @param now - 判定時刻（テスト用に注入可。既定は現在時刻）。
 * @param separator - 日付と時刻の区切り文字。
 * @returns `YYYYMMDD-HHmm` などの JST タイムスタンプ。
 */
export function filenameTimestampJst(
  now: Date = new Date(),
  separator: "-" | "_" = "-",
): string {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: NEXUS_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(now);
  const byType = new Map(parts.map((part) => [part.type, part.value]));
  return `${byType.get("year")}${byType.get("month")}${byType.get("day")}${separator}${byType.get("hour")}${byType.get("minute")}`;
}
